import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";

function PerformFitness() {
  const { t } = useLang();
  const modes    = t("performFitness.modes");
  const features = t("performFitness.features");

  return (
    <div className="dev-page">
      <div className="page-section-header">
        <span className="section-label">{t("performFitness.label")}</span>
        <div className="subhead">{t("performFitness.title")}</div>
        <p className="section-intro-inner">{t("performFitness.intro")}</p>
      </div>

      <div className="showcase-layout">
        <div className="showcase-main">

          <div className="tool-card showcase-card">
            <h3>{t("performFitness.overviewTitle")}</h3>
            <p>{t("performFitness.overview1")}</p>
            <p>{t("performFitness.overview2")}</p>
          </div>

          <div className="tool-card showcase-card">
            <h3>{t("performFitness.modesTitle")}</h3>
            <table className="showcase-table">
              <thead>
                <tr>
                  <th>{t("performFitness.typeCol")}</th>
                  <th>{t("performFitness.metricsCol")}</th>
                  <th>{t("performFitness.exampleCol")}</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(modes) && modes.map(({ type, metrics, example }) => (
                  <tr key={type}>
                    <td>{type}</td>
                    <td>{metrics}</td>
                    <td className="showcase-table-muted">{example}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="tool-card showcase-card">
            <h3>{t("performFitness.featuresTitle")}</h3>
            <ul className="showcase-list">
              {Array.isArray(features) && features.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
          </div>

        </div>

        <div className="showcase-sidebar">
          <div className="tool-card showcase-links-card">
            <div className="showcase-app-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="1" y="8" width="3" height="8" rx="1"/>
                <rect x="4" y="10" width="2" height="4" rx="0.5"/>
                <line x1="6" y1="12" x2="18" y2="12"/>
                <rect x="18" y="10" width="2" height="4" rx="0.5"/>
                <rect x="20" y="8" width="3" height="8" rx="1"/>
              </svg>
            </div>
            <h3>{t("performFitness.title")}</h3>
            <div className="project-tags" style={{marginBottom:"1.25rem"}}>
              <span className="tool-tag">React Native</span>
              <span className="tool-tag">iOS</span>
              <span className="tool-tag">SQLite</span>
            </div>
            <div className="showcase-btn-col">
              <a href="https://apps.apple.com/de/app/perform-fitness/id6760855330" target="_blank" rel="noreferrer" className="showcase-btn showcase-btn--primary">
                <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                {t("performFitness.appStore")}
              </a>
              <a href="https://github.com/its-really-me/perform-fitness-information" target="_blank" rel="noreferrer" className="showcase-btn showcase-btn--outline">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/>
                </svg>
                {t("performFitness.github")}
              </a>
              <Link to="/perform-fitness/privacy" className="showcase-btn showcase-btn--outline">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                </svg>
                {t("performFitness.privacyPolicy")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PerformFitness;
